import React, { useEffect } from "react";

import withSessionHandling, {
  type SessionHandlerProps,
} from "@/context/auth/withSessionHandling";
import { useHeaderContext } from "@/context/header/useHeaderContext";
import { type MediaPermissionScreenState } from "@/schemas/screen/configs";
import { MediaPermissionTabs, Screen } from "@/schemas/screen/tabs";
import ManagePermissionScreen from "@/screens/MediaPermission/ManagePermissionScreen";

function Page(props: SessionHandlerProps): React.JSX.Element {
  const { setCurrentScreen } = useHeaderContext();

  useEffect(() => {
    const newMediaTabScreen: MediaPermissionScreenState = {
      screenId: Screen.MEDIA_PERMISSION,
      activeTabId: MediaPermissionTabs.REQUESTED,
      filters: null,
    };
    setCurrentScreen(newMediaTabScreen);
  }, []);

  return <ManagePermissionScreen {...props} />;
}

export default withSessionHandling(Page);
